(() => {
  document.querySelectorAll('.bud-product').forEach((section) => {
    const heroImage = section.querySelector('[data-bud-product-image]');
    const lead = section.querySelector('[data-bud-product-lead]');
    const price = section.querySelector('[data-bud-product-price]');
    const submit = section.querySelector('[data-bud-product-submit]');
    const radios = section.querySelectorAll('input[name="id"]');
    const cachedImages = new Map();

    radios.forEach((radio) => {
      if (!radio.dataset.image || cachedImages.has(radio.dataset.image)) return;
      const image = new Image();
      image.src = radio.dataset.image;
      cachedImages.set(radio.dataset.image, image);
    });

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;

        const card = radio.closest('.bud-product__variant');
        section.querySelectorAll('.bud-product__variant').forEach((item) => {
          item.classList.toggle('is-selected', item === card);
        });

        if (heroImage && radio.dataset.image) {
          heroImage.classList.remove('is-switching');
          void heroImage.offsetWidth;
          heroImage.src = radio.dataset.image;
          heroImage.alt = radio.dataset.title || '';
          heroImage.classList.add('is-switching');
          window.setTimeout(() => heroImage.classList.remove('is-switching'), 420);
        }

        if (price && radio.dataset.price) {
          price.textContent = radio.dataset.price;
        }

        if (lead && radio.dataset.lead) {
          lead.textContent = radio.dataset.lead;
        }

        if (submit) {
          submit.disabled = radio.dataset.available !== 'true';
          submit.textContent = radio.dataset.available === 'true' ? 'Ajouter au panier' : 'Victime de son succès';
        }
      });
    });
  });
})();
